<template>
	<div
		class="flex lg:justify-center snap-x snap-mandatory gap-8 overflow-hidden overflow-x-scroll hide-scrollbars pt-3 pb-8 px-[35vw]"
	>
		<slot />
	</div>
</template>
